import { useOperador } from "./useOperador";
import { operadorEhAdmin } from "../Utils/cargos";

export const usePermissao = () => {
    const { permissoes, operador } = useOperador();

    // verifica se o operador possui um tipo de permissao (ex: tipo 10)
    const possuiTipo = (tipo) => {
        if (Number(tipo) === 99) return operadorEhAdmin(operador);
        return permissoes?.some((perm) => perm.tipo === tipo);
    };

    // verifica se o operador possui um IDPermissao específico
    const possuiIDPermissao = (IDPermissao) => {
        return permissoes?.some((perm) => perm.IDPermissao === IDPermissao);
    };

    return {
        possuiTipo,
        possuiIDPermissao,
        permissoes,
    };
};
